import { useFormContext } from "react-hook-form";

import styles from "./UserFormModal.module.css";

/**
 * Label + control + validation message for one field.
 *
 * Not `components/form/FormField`, but styled to match it: this renders the same 16px/700 label,
 * so Settings reads as the same application as the ~94 forms that use the shared component. It
 * stays a separate component only for what FormField does not offer — `htmlFor`, the two-column
 * `span`, and the `data-invalid` hook this modal's grid styles against.
 *
 * It used to carry its own 14px/500 label in a hardcoded grey, justified here as a deliberate
 * choice. Two label styles being simultaneously correct is worse than either one, so the type now
 * follows the majority; only the Bootstrap margin FormField inherits is left out, since this grid
 * spaces its own rows.
 */
export const ModalField = ({ name, label, htmlFor, children, span = 1 }) => {
  const {
    formState: { errors },
  } = useFormContext();

  const error = name ? errors[name] : undefined;

  return (
    <div
      className={`${styles.field} ${span === 2 ? styles.fieldWide : ""}`}
      data-invalid={error ? "true" : undefined}
    >
      {!!label && (
        <label className={styles.label} htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {!!error?.message && <p className={styles.error}>{error.message}</p>}
    </div>
  );
};
